module.exports = __webpack_public_path__ + "media/images/img-detail1-29a81c0b4bef796c173efbf0de5d52fa.jpg";